import request from '@/utils/request'

// 关闭会话
export function closeContext(data) {
    return request({
        url: '/chat/close',
        method: 'post',
        data,
    })
}

// 获取会话列表
export function getChatList(params) {
    return request({
        url: '/chat/findList',
        method: 'get',
        params,
    })
}
// 获取会话历史消息
export function getMessageList(params) {
    return request({
        url: '/chat/findMessageList',
        method: 'get',
        params,
    })
}

// 回复消息
export function replyMessage(data) {
    return request({
        url: '/chat/replyMessage',
        method: 'post',
        data,
    })
}
// 新增客服
export function createStaff(data) {
    return request({
        url: '/chat/createStaff',
        method: 'post',
        data,
    })
}
// 删除客服
export function removeStaff(data) {
    return request({
        url: '/chat/removeStaff',
        method: 'post',
        data,
    })
}
// 获取客服列表
export function getStaffList(params) {
  return request({
      url: '/chat/findStaffList',
      method: 'get',
      params,
  })
}
